import type { Configuration } from '@azure/msal-browser';

/**
 * MSAL-Konfiguration — Werte aus Client/wwwroot/appsettings.json und Client/Config.cs des
 * Altclients. Die Callback-Pfade entsprechen den Standardrouten von
 * Microsoft.Authentication.WebAssembly.Msal.
 */

export const MSAL_CLIENT_ID = '790c0fd9-4e51-44f8-aa87-98098a6e537b';

export const MSAL_AUTHORITY = 'https://login.microsoftonline.com/organizations/';

export const MSAL_API_SCOPE = 'api://f5da9bc0-878e-42ad-9bfc-e584e11eaf06/IWM.Seefracht.Api.Access';

export const GRAPH_USER_READ_SCOPE = 'https://graph.microsoft.com/User.Read';

export const API_SCOPES: string[] = [MSAL_API_SCOPE];

export const GRAPH_SCOPES: string[] = [GRAPH_USER_READ_SCOPE];

export const msalConfig: Configuration = {
  auth: {
    clientId: MSAL_CLIENT_ID,
    authority: MSAL_AUTHORITY,
    knownAuthorities: [],
    redirectUri: `${window.location.origin}/authentication/login-callback`,
    postLogoutRedirectUri: `${window.location.origin}/authentication/logout-callback`,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};
